class HeaderDrawer {
  constructor(el, opt) {
    this.el = el;
    this.$root = $("." + this.el);
    if (this.$root.length > 0) {
      this.bind();
    }
  }

  bind() {
    const $html = $("html");
    const $trigger = $(".js-header-drawer-trigger");
    const $close = $(".js-header-drawer-close");
    const $drawer = $("#header-drawer");

    const isOpen = () => $html.hasClass("is-header-drawer-open");

    const open = () => {
      if (isOpen()) return;
      $html.addClass("is-header-drawer-open");
      $trigger.attr({
        "aria-expanded": "true",
        "aria-label": "閉じる",
      });
      $drawer.attr("aria-hidden", "false");
      if (!$html.hasClass("is-hidden")) {
        scrollBan();
      }
    };

    const close = () => {
      if (!isOpen()) return;
      $html.removeClass("is-header-drawer-open");
      $trigger.attr({
        "aria-expanded": "false",
        "aria-label": "メニュー",
      });
      $drawer.attr("aria-hidden", "true");
      if ($html.hasClass("is-hidden")) {
        scrollBan();
      }
    };

    $trigger.on("click", function () {
      if (isOpen()) {
        close();
      } else {
        open();
      }
    });

    $close.on("click", function () {
      close();
    });

    $drawer.on("click", "a", function () {
      close();
    });

    $(document).on("keydown", function (e) {
      if (e.key === "Escape") {
        close();
      }
    });
  }
}